import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/null',
    name: 'null',
    component: () => import('../views/back')
  },
  {
    path: "*",
    component: () => import('../views/404.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/demo_code',
    name: 'demo_code',
    component: Home
  },
  {
    path: '/demo_member',
    name: 'demo_member',
    component: Home
  },
  {
    path: '/ysfbank',
    name: 'ysfbank',
    component: () => import('../views/ysfbank')
  },
  {
    path: '/Alipay',
    name: 'Alipay',
    component: () => import('../views/Alipay')
  },
  {
    path: '/gateway',
    name: 'gateway',
    component: () => import('../views/gateway')
  },
  {
    path: '/wxbank',
    name: 'wxbank',
    component: () => import('../views/wxbank')
  },
  {
    path: '/usdtTWD',
    name: 'usdtTWD',
    component: () => import('../views/usdt')
  },
  {
    path: '/newUsdt',
    name: 'newUsdt',
    component: () => import('../views/newUsdt')
  },
  {
    path: '/wallet_address',
    name: 'wallet_address',
    component: () => import('../views/wallet_address.vue')
  },
  {
    path: '/newgateway',
    name: 'newgateway',
    component: () => import('../views/newgateway.vue')
  },
  {
    path: '/newgateway2',
    name: 'newgateway2',
    component: () => import('../views/gatewayCopy.vue')
  },
  {
    path: '/fuzePay',
    name: 'fuzePay',
    component: () => import('../views/fuzePay.vue')
  },
  {
    path: '/bcp',
    name: 'bcp',
    component: () => import('../views/bcp.vue')
  },
  {
    path: '/cvs',
    name: 'cvs',
    component: () => import('../views/cvs.vue')
  },
  {
    path: '/gcash_rn',
    name: 'gcash_rn',
    component: () => import('../views/gcash.vue')
  },
  {
    path: '/sign_mode',
    name: 'sign_mode',
    component: () => import('../views/signCheck.vue')
  },
  {
    path: '/douyin',
    name: 'douyin',
    component: () => import('../views/douyin.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router